/**
 * Get the first set of times/timestamp values if two arrays are passed
 * when creating a game
 */
export function getBughouseGameTimeValues(timeValues) {
  if (Array.isArray(timeValues) && Array.isArray(timeValues[0])) {
    return timeValues[0];
  }

  return timeValues;
}
